import { render, staticRenderFns } from "./StorageRequest.vue?vue&type=template&id=4df5c410&"
import script from "./StorageRequest.vue?vue&type=script&lang=js&"
export * from "./StorageRequest.vue?vue&type=script&lang=js&"
import style0 from "./StorageRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports